module.exports = __webpack_public_path__ + "static/mockup2-0689ed6ce20de45ff47bc09eef3171e7.png";